import { CheckoutFormDataFragment$data } from '__generated__/CheckoutFormDataFragment.graphql';

interface ExtractCheckoutDataStepParameter {
  sections: CheckoutFormDataFragment$data['sections'];
  sectionId: string;
  stepPath: string;
}

type CheckoutDataStep =
  CheckoutFormDataFragment$data['sections'][0]['steps'][0];

export function extractCheckoutDataStep({
  sections,
  sectionId,
  stepPath,
}: ExtractCheckoutDataStepParameter): CheckoutDataStep | null {
  const pickedSection = sections.find(
    (section) => section.sectionId === sectionId,
  );

  const pickedStep =
    pickedSection?.steps?.find((step) => step.stepPath === stepPath) || null;

  return pickedStep;
}
